import { Typography } from '@stern-ui/ui';
import { CellContext, createColumnHelper } from '@tanstack/react-table';

import { DataTableObject, TableConfigType } from '@/components/PatientDataTable';
import {
	FetchPatientScreeningContextObject,
	patientSurveyRowProps,
	SurveyReviewEditCell,
} from '@/features/patientScreening';

import { TRIAL_SITES } from '../consts';

const columnHelper = createColumnHelper<DataTableObject>();

type CellContextExtended = CellContext<DataTableObject, string> &
	FetchPatientScreeningContextObject;

const TrialSitePatientSurveyColumns = [
	columnHelper.accessor('survey_name', {
		header: () => (
			<Typography variant='bodySmall'>
				{TRIAL_SITES.CONFIGS.SURVEY_LIST.TABLE.COLUMNS.A.LABEL}
			</Typography>
		),
	}),
	columnHelper.display({
		id: TRIAL_SITES.CONFIGS.SURVEY_LIST.TABLE.COLUMNS.B.ID,
		cell: (info: unknown) => (
			<SurveyReviewEditCell info={info as CellContextExtended} isEditEnabled={false} />
		),
	}),
];

export const trialSitePatientSurveyConfig: TableConfigType = {
	columns: TrialSitePatientSurveyColumns,
	rowProps: patientSurveyRowProps,
};
